import { Component, input, output } from "@angular/core";
import {
  FormControl,
  Validators,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { PasswordService } from "src/app/services/password.service";

@Component({
  selector: "app-change-password",
  imports: [TranslatePipe, ReactiveFormsModule],
  templateUrl: "./change-password.component.html",
  styles: ``,
})
export class ChangePasswordComponent {
  changePassword = output<{ oldPassword: string; newPassword: string }>();
  busy = input<boolean>();

  passwordComplexity = this.passwordService.defaultPasswordComplexity();

  oldPassword = new FormControl<string>("", [Validators.required]);
  newPassword = new FormControl<string>("", [
    this.passwordService.passwordComplexityValidator(this.passwordComplexity),
  ]);

  newPasswordCheck = new FormControl<string>("", [Validators.required]);

  form = new FormGroup(
    {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
      newPasswordCheck: this.newPasswordCheck,
    },
    [this.passwordService.passwordsMustMatchValidator()],
  );

  constructor(private readonly passwordService: PasswordService) {}

  submit() {
    if (this.form.valid) {
      this.changePassword.emit({
        oldPassword: this.oldPassword.value || "",
        newPassword: this.newPassword.value || "",
      });
    }
  }
}
